import { useInfiniteQuery  } from "react-query"
import api from ".."
import { TApiResponse } from "../../types/api"
import { getErrorToast } from "../../constructor/helpers/toasts"
import { TNotificationItem } from "../../types/global"
import { useAuth } from "../../modules/auth"

const LIMIT = 5
type FetchParams = {
    pageParam?: number
    signal?: AbortSignal
}

const useNotifications = () => {
    const {currentUser} = useAuth()
    const userId = currentUser?.id
    const fetchKey = ['notifications', 'get', {user_id: userId}]

    const fetchFunction = ({pageParam, signal} : FetchParams) =>
        api<Array<TNotificationItem>>('notifications', 'get', {
            user_id: userId,
            page: pageParam ?? 1,
            limit: LIMIT,
        }, {signal})

    const {data, isLoading, isFetching, error, fetchNextPage, hasNextPage, refetch} =
        useInfiniteQuery(fetchKey, fetchFunction, {
            enabled: Boolean(userId),
            refetchOnWindowFocus: false,
            retry: false,
            refetchInterval: 600000,
            refetchIntervalInBackground: true,
            getNextPageParam: (lastPage, pages) => {
                const totalPages = lastPage.detail?.pages_count
                const nextPage = pages.length + 1
                return nextPage <= totalPages ? nextPage : undefined
            },
        })

    const notifications = data?.pages.flatMap((page) => page.data) || []

    const totalCount = data?.pages?.[0]?.detail?.rows_count || 0

    return {
        isLoading,
        isFetching,
        error,
        notifications,
        totalCount,
        fetchNextPage,
        hasNextPage,
        refetch,
    }
}

export default useNotifications